import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import Swal from 'sweetalert2';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Constants} from '../constants';
import {DataManagementService} from '../services/data-management.service';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {AppSettings} from '../../app-settings';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-nominations",
  templateUrl: "./nominations.component.html",
  styleUrls: ["./nominations.component.css"],
})
export class NominationsComponent implements OnInit {
  @ViewChild("addEditNominationModal") addEditNominationModal: TemplateRef<any>;
  @ViewChild("editRegistrationDetailsModal")
  editRegistrationDetailsModal: TemplateRef<any>;

  public modalReference: NgbModalRef;
  downloadNominations = AppSettings.DOWNLOAD_NOMINATIONS;
  nominations = [];
  errorMessage;
  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  selectUndefinedOptionValue = undefined;
  programmeId = "0";
  termId = "0";
  pocId;
  academicYear;
  presentTerm;
  termEndTime;
  currentTime;
  isRoundExists = false;
  academicYearId = "0";
  programmes;
  terms;
  studentDetails;
  editNominationFlag;
  incomingStudentId: any;
  incomingStudentFormData: any;
  country: any;
  pocDetails: any;
  addressFlag = false;
  formData: FormData;
  fileList: FileList;
  file: File;
  visaAttachment = Constants.VISA_ATTACHMENT;
  mbaTranscriptAttachment = Constants.LATEST_TRANSCRIPT_ATTACHMENT;
  photoAttachment = Constants.PHOTO_ATTACHMENT;
  cvAttachment = Constants.RESUME_ATTACHMENT;
  incomingPassportAttachment = Constants.PASSPORT_ATTACHMENT;
  isFormDataLoading: boolean = false;
  studentIncomingTermId: any;


  constructor(
    private modal: NgbModal,
    private dmService: DataManagementService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  getNominations(): void {
    this.isRoundExists = false;
    this.nominations = undefined;
    this.dmService
      .javaGetDataCallByParameter(
        Constants.NOMINATIONS,
        this.pocId +
          "/" +
          this.termId +
          "/" +
          this.programmeId +
          "/" +
          this.academicYearId
      )
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.nominations = response.data.nominations;
            this.programmes = response.data.programmes;
            this.terms = response.data.incoming_terms;
            // this.academicYear = response.data.academic_year;
            this.presentTerm = response.data.present_term;
            if (this.presentTerm !== null && this.presentTerm !== undefined) {
              this.termEndTime = this.presentTerm.nomination_end_date;
              this.currentTime = new Date().getTime();
              this.termId = this.presentTerm.incoming_term_id;
              if (this.currentTime < this.termEndTime) {
                this.isRoundExists = true;
              }
            }
            if (this.programmes !== null && this.programmes !== undefined) {
              for (let i = 0; i < this.programmes.length; i++) {
                const obj = this.programmes[i];
                if (obj.programme_code === Constants.PROGRAMME_PGP_CODE) {
                  this.programmeId = obj.programme_id;
                }
              }
            }
            // if (this.programmes !== null && this.programmes !== undefined &&
            //     this.academicYear.length > 0 && this.academicYearId === '0') {
            //     this.academicYearId = this.academicYear[0].academic_year_id;
            // }
            if (this.nominations.length <= 0) {
              this.errorMessage = "There is no data available for nominations";
            } else {
              this.dtTrigger.next();
            }
          } else if (response.status === "fail") {
            if (
              response.hasOwnProperty("message") &&
              response.message !== null
            ) {
              this.errorMessage = response.message;
            } else {
              this.errorMessage =
                "Something went wrong. Please contact support team";
            }
          }
        },
        (error) => {
          console.log(error);
          this.errorMessage = "Server Error";
          // this.errorMessage = error;
        }
      );
  }

  getDateForForm(dateTime): string {
    if (
      dateTime === undefined ||
      dateTime === null ||
      dateTime === "" ||
      dateTime === "undefined"
    ) {
      return "";
    }
    return moment(dateTime).format("YYYY-MM-DD");
  }

  getDate(dateTime): string {
    if (
      dateTime === undefined ||
      dateTime === null ||
      dateTime === "" ||
      dateTime === "undefined"
    ) {
      return "";
    }
    return moment(dateTime).format("Do MMM YYYY");
  }

  openAddNominationModal(): void {
    this.studentDetails = {
      programme_id: this.programmeId,
      term_id: this.termId,
      minimum_credits: 0,
      maximum_credits: 0,
    };
    this.modalReference = this.modal.open(this.addEditNominationModal, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
  }

  openEditNominationModal(nomination): void {
    this.editNominationFlag = true;
    this.studentDetails = nomination;
    this.studentDetails.dob = this.getDateForForm(nomination.dob);
    this.modalReference = this.modal.open(this.addEditNominationModal, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
  }

  addEditNomination(): void {
    if (
      !this.studentDetails.hasOwnProperty("programme_id") ||
      !this.studentDetails.hasOwnProperty("term_id")
    ) {
      Swal({
        type: "warning",
        title: "Warning",
        html: "All fields are required",
      });
      return;
    }
    if (this.editNominationFlag === true) {
      this.editNomination();
    } else {
      this.addNomination();
    }
  }

  addNomination(): void {
    const that = this;
    let addNominationResponse;
    this.studentDetails["user_id"] = JSON.parse(
      localStorage.getItem("epas_user")
    ).user_id;
    this.studentDetails["poc_id"] = this.pocId;
    console.log(this.studentDetails);
    Swal({
      title: "Confirm",
      type: "question",
      text: "Do you want to add this nomination?",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#5cb85c",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService
            .javaPostDataCall(that.studentDetails, Constants.ADD_NOMINATION)
            .subscribe(
              (resData) => {
                addNominationResponse = resData;
                resolve(addNominationResponse);
              },
              (error) => {
                addNominationResponse = error;
                reject(addNominationResponse);
              }
            );
        });
      },
      allowOutsideClick: false,
    })
      .then(
        function (result) {
          if (result.hasOwnProperty("value")) {
            if (addNominationResponse.status === "success") {
              that.router
                .navigateByUrl("/RefreshComponent", {
                  skipLocationChange: true,
                })
                .then(() => that.router.navigate(["nominations"]));
              Swal({
                title: "Success",
                type: "success",
                showCancelButton: false,
                showConfirmButton: true,
                html: "<p>Nomination Added successfully.</p>",
              }).then(
                function (res) {
                  console.log(res);
                },
                function (timer) {
                  console.log(timer);
                }
              );
              that.closeModal();
            } else if (addNominationResponse.status === "fail") {
              if (addNominationResponse.message !== "null") {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html:
                    "<p>Unable to add Nomination, " +
                    addNominationResponse.message +
                    "</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              } else {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html: "<p>Unable to add Nomination, Please contact support team.</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              }
            }
          }
        },
        function (cancel) {
          console.log(cancel);
        }
      )
      .catch(function (error) {
        console.log(error);
      });
  }

  editNomination(): void {
    const that = this;
    let editNominationResponse;
    this.studentDetails["user_id"] = JSON.parse(
      localStorage.getItem("epas_user")
    ).user_id;
    this.studentDetails["poc_id"] = JSON.parse(
      localStorage.getItem("epas_user")
    ).roles[0].epas_user_role_mapping.poc_id;
    Swal({
      title: "Confirm",
      type: "question",
      text: "Do you want to edit this nomination?",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#5cb85c",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService
            .javaPostDataCall(that.studentDetails, Constants.EDIT_NOMINATION)
            .subscribe(
              (resData) => {
                editNominationResponse = resData;
                resolve(editNominationResponse);
              },
              (error) => {
                editNominationResponse = error;
                reject(editNominationResponse);
              }
            );
        });
      },
      allowOutsideClick: false,
    })
      .then(
        function (result) {
          if (result.hasOwnProperty("value")) {
            if (editNominationResponse.status === "success") {
              that.router
                .navigateByUrl("/RefreshComponent", {
                  skipLocationChange: true,
                })
                .then(() => that.router.navigate(["nominations"]));
              Swal({
                title: "Success",
                type: "success",
                showCancelButton: false,
                showConfirmButton: true,
                html: "<p>Nomination Updated successfully.</p>",
              }).then(
                function (res) {
                  console.log(res);
                },
                function (timer) {
                  console.log(timer);
                }
              );
              that.closeModal();
            } else if (editNominationResponse.status === "fail") {
              if (editNominationResponse.message !== "null") {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html:
                    "<p>Unable to update Nomination, " +
                    editNominationResponse.message +
                    "</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              } else {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html: "<p>Unable to update Nomination, Please contact support team.</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              }
            }
          }
        },
        function (cancel) {
          console.log(cancel);
        }
      )
      .catch(function (error) {
        console.log(error);
      });
  }

  sendNominationEmail(nomination): void {
    const that = this;
    let sendNominationResponse;
    nomination["user_id"] = JSON.parse(
      localStorage.getItem("epas_user")
    ).user_id;
    nomination["poc_id"] = this.pocId;
    console.log(nomination);
    Swal({
      title: "Confirm",
      type: "question",
      text: "Do you want to send nomination details through email?",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#5cb85c",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService
            .javaPostDataCall(nomination, Constants.SEND_NOMINATION_EMAIL)
            .subscribe(
              (resData) => {
                sendNominationResponse = resData;
                resolve(sendNominationResponse);
              },
              (error) => {
                sendNominationResponse = error;
                reject(sendNominationResponse);
              }
            );
        });
      },
      allowOutsideClick: false,
    })
      .then(
        function (result) {
          if (result.hasOwnProperty("value")) {
            if (sendNominationResponse.status === "success") {
              that.router
                .navigateByUrl("/RefreshComponent", {
                  skipLocationChange: true,
                })
                .then(() => that.router.navigate(["nominations"]));
              Swal({
                title: "Success",
                type: "success",
                showCancelButton: false,
                showConfirmButton: true,
                html: "<p>Successfully send nomination details.</p>",
              }).then(
                function (res) {
                  console.log(res);
                },
                function (timer) {
                  console.log(timer);
                }
              );
              that.closeModal();
            } else if (sendNominationResponse.status === "fail") {
              if (sendNominationResponse.message !== "null") {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html:
                    "<p>Unable to send nomination details, " +
                    sendNominationResponse.message +
                    "</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              } else {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html: "<p>Unable to send nomination details, Please contact support team.</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              }
            }
          }
        },
        function (cancel) {
          console.log(cancel);
        }
      )
      .catch(function (error) {
        console.log(error);
      });
  }

  withdrawNomination(nomination): void {
    const that = this;
    let withdrawNominationResponse;
    const data = {
      incoming_student_id: nomination.incoming_student_id,
      term_id: nomination.term_id,
      user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
      poc_id: this.pocId,
      state_name_id: Constants.INCOMING_STUDENT_WITHDRAWN,
    };
    Swal({
      title: "Confirm",
      type: "question",
      text: "Do you want to withdraw this nomination?",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#5cb85c",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService
            .javaPostDataCall(data, Constants.CHANGE_STUDENT_STATE)
            .subscribe(
              (resData) => {
                withdrawNominationResponse = resData;
                resolve(withdrawNominationResponse);
              },
              (error) => {
                withdrawNominationResponse = error;
                reject(withdrawNominationResponse);
              }
            );
        });
      },
      allowOutsideClick: false,
    })
      .then(
        function (result) {
          if (result.hasOwnProperty("value")) {
            if (withdrawNominationResponse.status === "success") {
              that.router
                .navigateByUrl("/RefreshComponent", {
                  skipLocationChange: true,
                })
                .then(() => that.router.navigate(["nominations"]));
              Swal({
                title: "Success",
                type: "success",
                showCancelButton: false,
                showConfirmButton: true,
                html: "<p>Nomination withdrawn successfully.</p>",
              }).then(
                function (res) {
                  console.log(res);
                },
                function (timer) {
                  console.log(timer);
                }
              );
              that.closeModal();
            } else if (withdrawNominationResponse.status === "fail") {
              if (
                withdrawNominationResponse.message !== "" ||
                withdrawNominationResponse.message !== null
              ) {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html:
                    "<p>Unable to withdraw Nomination, " +
                    withdrawNominationResponse.message +
                    "</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              } else {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html: "<p>Unable to withdraw Nomination, Please contact support team.</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              }
            }
          }
        },
        function (cancel) {
          console.log(cancel);
        }
      )
      .catch(function (error) {
        console.log(error);
      });
  }

  reNominate(nomination): void {
    const that = this;
    let reNominateResponse;
    const data = {
      incoming_student_id: nomination.incoming_student_id,
      term_id: nomination.term_id,
      user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
      poc_id: this.pocId,
      state_name_id: Constants.INCOMING_STUDENT_NOMINATED,
    };
    Swal({
      title: "Confirm",
      type: "question",
      text: "Do you want to re-nominate this nomination?",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#5cb85c",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService
            .javaPostDataCall(data, Constants.CHANGE_STUDENT_STATE)
            .subscribe(
              (resData) => {
                reNominateResponse = resData;
                resolve(reNominateResponse);
              },
              (error) => {
                reNominateResponse = error;
                reject(reNominateResponse);
              }
            );
        });
      },
      allowOutsideClick: false,
    })
      .then(
        function (result) {
          if (result.hasOwnProperty("value")) {
            if (reNominateResponse.status === "success") {
              that.router
                .navigateByUrl("/RefreshComponent", {
                  skipLocationChange: true,
                })
                .then(() => that.router.navigate(["nominations"]));
              Swal({
                title: "Success",
                type: "success",
                showCancelButton: false,
                showConfirmButton: true,
                html: "<p>Re-nominated successfully.</p>",
              }).then(
                function (res) {
                  console.log(res);
                },
                function (timer) {
                  console.log(timer);
                }
              );
              that.closeModal();
            } else if (reNominateResponse.status === "fail") {
              if (
                reNominateResponse.message !== "" ||
                reNominateResponse.message !== null
              ) {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html:
                    "<p>Unable to re-nominate Nomination, " +
                    reNominateResponse.message +
                    "</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              } else {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html: "<p>Unable to re-nominate Nomination, Please contact support team.</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              }
            }
          }
        },
        function (cancel) {
          console.log(cancel);
        }
      )
      .catch(function (error) {
        console.log(error);
      });
  }

  getFormData(incomingStudentId): void {
    this.incomingStudentId = incomingStudentId;
    this.isFormDataLoading = true;
    this.errorMessage = undefined;

      if (this.modalReference) {
              this.modalReference.close();
            }

            this.modalReference = this.modal.open(
              this.editRegistrationDetailsModal,
              {
                size: "lg",
                backdrop: "static",
                keyboard: false,
              }
            );
    this.dmService
      .javaGetDataCallByParameter(
        Constants.INCOMING_STUDENT_REGISTRATION,
        this.incomingStudentId
      )
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.isFormDataLoading = false; 
            this.incomingStudentFormData =
              response.data.incoming_student_details;
            this.country = response.data.country;
            this.pocDetails = response.data.poc_details;
            this.presentTerm = response.data.present_term;
            this.incomingStudentFormData.dob = this.getDateForRegistrationForm(
              this.incomingStudentFormData.dob
            );
             this.incomingStudentFormData.passport_issue_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.passport_issue_date
              );
            this.incomingStudentFormData.expiry_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.expiry_date
              );
                this.incomingStudentFormData.visa_issue_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.visa_issue_date
              );
            this.incomingStudentFormData.visa_expiry_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.visa_expiry_date
              );
            this.incomingStudentFormData.current_address_valid_till =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.current_address_valid_till
              );
            this.incomingStudentFormData.period_of_study_from =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.period_of_study_from
              );
            this.incomingStudentFormData.period_of_study_to =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.period_of_study_to
              );
            this.incomingStudentFormData.accommodation_from =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.accommodation_from
              );
            this.incomingStudentFormData.accommodation_to =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.accommodation_to
              );
          
          } else if (response.status === "fail") {
            this.errorMessage = response.message;
          }
        },
        (error) => {
          console.log(error);
          this.isFormDataLoading = false;
          this.errorMessage = "Server Error";
        }
      );
  }

     getFormDataForEdit(incomingStudentId,incomingTermId): void {
    this.incomingStudentId = incomingStudentId;
    this.studentIncomingTermId = incomingTermId
    this.isFormDataLoading = true;
    this.errorMessage = undefined;
    this.incomingStudentFormData = {};
        this.country = {};
            this.pocDetails = {};

             if (this.modalReference) {
        this.modalReference.close();
    }


 this.modalReference = this.modal.open(
        this.editRegistrationDetailsModal,
        {
            size: "lg",
            backdrop: "static",
            keyboard: false,
        }
    );

     const requestData = {
        incoming_student_id: this.incomingStudentId,
        incoming_term_id: this.studentIncomingTermId
    };


    this.dmService
      .javaPostDataCall(
        requestData,
                Constants.INCOMING_STUDENT_REGISTRATION_BY_TERM_ID,
      )
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.isFormDataLoading = false; 
            this.incomingStudentFormData =
              response.data.incoming_student_details;
            this.country = response.data.country;
            this.pocDetails = response.data.poc_details;
            this.presentTerm = response.data.present_term;
            this.incomingStudentFormData.dob = this.getDateForRegistrationForm(
              this.incomingStudentFormData.dob
            );
            this.incomingStudentFormData.passport_issue_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.passport_issue_date
              );
            this.incomingStudentFormData.expiry_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.expiry_date
              );
              this.incomingStudentFormData.visa_issue_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.visa_issue_date
              );
            this.incomingStudentFormData.visa_expiry_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.visa_expiry_date
              );
            this.incomingStudentFormData.current_address_valid_till =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.current_address_valid_till
              );
            this.incomingStudentFormData.period_of_study_from =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.period_of_study_from
              );
            this.incomingStudentFormData.period_of_study_to =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.period_of_study_to
              );
            this.incomingStudentFormData.accommodation_from =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.accommodation_from
              );
            this.incomingStudentFormData.accommodation_to =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.accommodation_to
              );
            // if (this.modalReference) {
            //   this.modalReference.close();
            // }

            // this.modalReference = this.modal.open(
            //   this.editRegistrationDetailsModal,
            //   {
            //     size: "lg",
            //     backdrop: "static",
            //     keyboard: false,
            //   }
            // );
          } else if (response.status === "fail") {
            this.errorMessage = response.message;
          }
        },
        (error) => {
          this.isFormDataLoading = false;
          console.log(error);
          this.errorMessage = "Server Error";
        }
      );
  }

  getDateForRegistrationForm(dateTime): string {
    if (
      dateTime === undefined ||
      dateTime === null ||
      dateTime === "" ||
      dateTime === "undefined"
    ) {
      return "";
    }
    return moment(dateTime).tz("Asia/Kolkata").format("YYYY-MM-DD");
  }

  finalSubmitRegistrationForm(e): void {
    e.preventDefault();
    this.incomingStudentFormData.is_final_submitted = true;
    if (this.incomingStudentFormData.incoming_student_id === 0) {
      this.incomingStudentFormData.incoming_student_id = this.incomingStudentId;
    }
    if (this.addressFlag === true) {
      this.incomingStudentFormData.permanent_address_line1 =
        this.incomingStudentFormData.current_address_line1;
      this.incomingStudentFormData.permanent_address_line2 =
        this.incomingStudentFormData.current_address_line2;
      this.incomingStudentFormData.permanent_city =
        this.incomingStudentFormData.current_city;
      this.incomingStudentFormData.permanent_country_id =
        this.incomingStudentFormData.current_country_id;
      this.incomingStudentFormData.permanent_zipcode =
        this.incomingStudentFormData.current_zipcode;
    }
    this.incomingStudentFormData["user_id"] = JSON.parse(
      localStorage.getItem("epas_user")
    ).user_id;
    const that = this;
    let uploadResponse;
    Swal({
      title: "Confirm",
      type: "question",
      text: " Are you sure you want to continue?",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#4cb84c",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService
            .javaPostDataCall(
              that.incomingStudentFormData,
              Constants.FINAL_INCOMING_STUDENT_REGISTRATION
            )
            .subscribe(
              (data) => {
                uploadResponse = data;
                resolve(uploadResponse);
              },
              (error) => {
                uploadResponse = error;
                reject(uploadResponse);
              }
            );
        });
      },
      allowOutsideClick: false,
    }).then(function (result) {
      if (result.hasOwnProperty("value")) {
        if (uploadResponse.status === "success") {
          that.router
            .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
            .then(() =>
              that.router.navigate(["nominations"], { replaceUrl: true })
            );
          if (uploadResponse.hasOwnProperty("message")) {
            Swal({
              title: "Success",
              type: "success",
              html: uploadResponse.message,
            });
          } else {
            Swal({
              title: "Success",
              type: "success",
              html: "<p>Successfully submitted registration.</p>",
            });
          }
          that.closeModal();
        } else if (uploadResponse.status === "fail") {
          if (uploadResponse.hasOwnProperty("message")) {
            Swal({
              type: "error",
              title: "Fail",
              html: uploadResponse.message,
            });
          } else {
            Swal({
              type: "error",
              title: "Fail",
              text: "Unable to upload registration form, Please contact support team.",
            });
          }
        }
      }
    });
  }

  uploadIncomingStudentDetails(): void {
    this.incomingStudentFormData.is_final_submitted = true;
    if (this.incomingStudentFormData.incoming_student_id === 0) {
      this.incomingStudentFormData.incoming_student_id = this.incomingStudentId;
    }
    if (this.addressFlag === true) {
      this.incomingStudentFormData.permanent_address_line1 =
        this.incomingStudentFormData.current_address_line1;
      this.incomingStudentFormData.permanent_address_line2 =
        this.incomingStudentFormData.current_address_line2;
      this.incomingStudentFormData.permanent_city =
        this.incomingStudentFormData.current_city;
      this.incomingStudentFormData.permanent_country_id =
        this.incomingStudentFormData.current_country_id;
      this.incomingStudentFormData.permanent_zipcode =
        this.incomingStudentFormData.current_zipcode;
    }
    this.incomingStudentFormData["user_id"] = JSON.parse(
      localStorage.getItem("epas_user")
    ).user_id;
    this.dmService
      .javaPostDataCall(
        this.incomingStudentFormData,
        Constants.INCOMING_STUDENT_REGISTRATION
      )
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.toastr.success(
              "Successfully updated the registration form.",
              "Success"
            );
           // this.getFormData(this.incomingStudentId);
            this.getFormDataForEdit(this.incomingStudentId,this.studentIncomingTermId);
          } else if (response.status === "fail") {
            this.toastr.warning(response.message, "Fail");
          }
        },
        (error) => {
          console.log(error);
          this.toastr.error("Server Error", "Error");
        }
      );
  }

  sameAsCurrentAddress(): void {
    this.addressFlag = !this.addressFlag;
  }

  fileChange(event, documentId) {
    if (event.target.files.length > 1) {
      throw new Error("Cannot upload multiple files on the entry");
    }
    this.fileList = event.target.files;
    const userId = JSON.parse(localStorage.getItem("epas_user")).user_id;
    this.file = event.target.files[0];
    this.formData = new FormData();
    this.formData.append("file", this.file);
    this.formData.append(
      "incoming_student_id",
      this.incomingStudentFormData.incoming_student_id
    );
    this.formData.append("document_type_id", documentId);
    this.formData.append("user_id", userId);
    this.uploadDocument();
  }

  uploadDocument() {
    if (this.formData === undefined || this.formData === null) {
      this.toastr.warning("Please select the file and .", "Required");
      return;
    }
    this.dmService.javaUploadIncomingStudentDocument(this.formData).subscribe(
      (response) => {
        if (response.status === "success") {
          this.formData = undefined;
          this.toastr.success(
            "Successfully uploaded the file " + this.file.name,
            "Success"
          );
          this.getFormDataForEdit(this.incomingStudentId,this.studentIncomingTermId);
        //  this.getFormData(this.incomingStudentId);
        } else if (response.status === "fail") {
          if (response.hasOwnProperty("message")) {
            this.toastr.warning(response.message, "Fail");
          } else {
            this.toastr.warning(
              "Something went wrong. please contact support team",
              "Fail"
            );
          }
        }
      },
      (error) => {
        console.log(error);
        this.toastr.warning(
          "Something went wrong. please contact support team",
          "Fail"
        );
      }
    );
  }

  deleteDocument(documentId) {
    const finalData = {
      incoming_student_id: this.incomingStudentFormData.incoming_student_id,
      user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
    };
    if (documentId === Constants.VISA_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.visa_attachment_id;
      finalData["document_type_id"] = Constants.VISA_ATTACHMENT;
    } else if (documentId === Constants.LATEST_TRANSCRIPT_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.latest_transcript_attachment_id;
      finalData["document_type_id"] = Constants.LATEST_TRANSCRIPT_ATTACHMENT;
    } else if (documentId === Constants.PASSPORT_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.passport_attachment_id;
      finalData["document_type_id"] = Constants.PASSPORT_ATTACHMENT;
    } else if (documentId === Constants.PHOTO_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.photo_attachment_id;
      finalData["document_type_id"] = Constants.PHOTO_ATTACHMENT;
    } else if (documentId === Constants.RESUME_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.resume_attachment_id;
      finalData["document_type_id"] = Constants.RESUME_ATTACHMENT;
    } else if (documentId === Constants.HOSTEL_CODE_OF_CONDUCT_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.hostel_coc_attachment_id;
      finalData["document_type_id"] =
        Constants.HOSTEL_CODE_OF_CONDUCT_ATTACHMENT;
    } else if (documentId === Constants.RELEASE_CUM_IDENTITY_BOND_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.release_cum_identity_bond_attachment_id;
      finalData["document_type_id"] =
        Constants.RELEASE_CUM_IDENTITY_BOND_ATTACHMENT;
    } else if (documentId === Constants.HEALTH_CERTIFICATE_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.health_certificate_attachment_id;
      finalData["document_type_id"] = Constants.HEALTH_CERTIFICATE_ATTACHMENT;
    }
    this.dmService
      .javaPostDataCall(finalData, Constants.INCOMING_STUDENT_FILE_DELETE)
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.toastr.success("Successfully deleted the file ", "Success");
            this.getFormDataForEdit(this.incomingStudentId,this.studentIncomingTermId);
          //  this.getFormData(this.incomingStudentId);
          } else if (response.status === "fail") {
            if (response.hasOwnProperty("message")) {
              this.toastr.warning(response.message, "Fail");
            } else {
              this.toastr.warning(
                "Something went wrong. please contact support team",
                "Fail"
              );
            }
          }
        },
        (error) => {
          console.log(error);
          this.toastr.warning(
            "Something went wrong. please contact support team",
            "Fail"
          );
        }
      );
  }

  closeModal(): void {
    this.editNominationFlag = false;
    this.studentDetails = {};
    this.incomingStudentId = undefined;
    this.incomingStudentFormData = {};
    this.country = {};
    this.pocDetails = {};
    this.modalReference.close();
    this.isFormDataLoading = false;
    this.errorMessage = undefined;
  }

  ngOnInit() {
    this.pocId = JSON.parse(
      localStorage.getItem("epas_user")
    ).roles[0].epas_user_role_mapping.poc_id;
    this.getNominations();
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false,
    };
  }
}
